export enum EVacancyStatus {
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED',
}

export interface IVacancyLocation {
  name: string
  lat: number
  lng: number
}

export interface IVacancy {
  _id: string
  name: string
  description: string
  photos: string[] // обложка — photos[0]
  salary: number // рублей; 0 — «По договорённости»
  phone: string
  contact_name: string
  location: IVacancyLocation
  status: EVacancyStatus
  slug: string
  createdAt: string
  updatedAt: string
}

export interface IVacancyBody {
  name: string
  description: string
  salary: number
  phone: string
  contact_name: string
  location: IVacancyLocation
  photos?: File[] // новые файлы
  existing_photos?: string[] // оставленные фото по порядку; при правке — вместе с photos
  status?: EVacancyStatus
}
